module.exports = "/lucky-balls/img/combos/210-.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/210-.png
// module id = 1000
// module chunks = 0